// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"179ef7ba","755":"684c5bd0","769":"817824bd","974":"d0bc3f48"}[chunkId] + ".chunk.js";
};